<template>
    <div>
        <table class="table table-striped">
            <thead>
                <tr>
                    <th>
                        <button type="button" class="btn btn-outline-primary btn-sm"
                            @click="create ()">
                            <i class="fas fa-plus"></i>
                        </button>
                    </th>
                    <th v-for="(campo, index2) in lista_campos" :key="index2">
                        {{ campo.display }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in $props.data" :key="index">
                    <td width="5%">
                        <button type="button" class="btn btn-outline-danger btn-sm">
                            <i class="fas fa-trash"></i>
                        </button>
                    </td>
                    <td v-for="(campo, index2) in lista_campos" :key="index2">
                        {{ getValue(item, campo.name) }} 
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Modal -->
        <div class="modal fade" id="cadastroDetailModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{ $props.metadados.metadados.title }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <cadastro-form 
                        :campos="$props.metadados.metadados.edit_fields"></cadastro-form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    <button type="button" class="btn btn-primary">Atualizar</button>
                </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {
    data () { 
        return {};
    },
    props: ['data', 'metadados'],
    computed: { 
        lista_campos () { 
            return this.$props.metadados.metadados.list_fields.filter((item) => { 
                            return !item['hide'];
                        });
        }
    },
    methods: { 
        getValue (item, campo) {
            return _.get(item, campo);
        },
        create () { 
            $('#cadastroDetailModal').modal('show');
        }
    }
}
</script>